import {IBooking, IPosition} from "shared-types/SharedTypes";
import {FloorplanTableStatusIcon} from "floorplan-v2/app/components/Tables/StatusButton/types";
import {INewSlotPress} from "floorplan-v2/app/reducers/tableInteractions/types";
import {FloorplanTableShape} from "floorplan-v2/app/components/Tables/TableRect/types";
import {DESIGN_SCALE} from "floorplan-v2/app/components/Tables/Chair/types";
import {Graphics, Sprite} from "pixi.js";
import {IPageCoords} from "floorplan-v2/app/services/PositionService/types";
import {TableStatusEnum} from 'floorplan-v2/app/services/floorplanStatusService/types';
import { DraggedBookingSourceEnum } from 'floorplan-v2/app/reducers/tableDrag/types';

export const SLOT_H = 32 * DESIGN_SCALE;
export const SLOT_W = 106 * DESIGN_SCALE;

export const STROKE_W1 = 5 * DESIGN_SCALE;
export const STROKE_W2 = 2 * DESIGN_SCALE;

export const GREY1 = 0xC2C2C2;
export const GREY2 = 0xF1F0F1;
export const GREY3 = 0xDFDFDF;
export const GREY4 = 0x797879;
export const GREY5 = 0x333333;
export const GREY6 = 0xE7E5E3;
export const GREY7 = 0xF4F2F1;
export const GREEN1 = 0x87C93D;
export const MAGENTA1 = 0xFAD1E3;
export const MAGENTA2 = 0x992662;

export interface IHoverStateGraphics {
  bg: Sprite;
  hoverBg: Graphics;
  pressedBg: Graphics;
  draggedOverBg?: Graphics;
  dottedOutline?: Sprite;
}

export enum SlotHoverState {
  default = 'default',
  hover = 'hover',
  pressed = 'pressed',
  draggedOver = 'draggedOver',
}

export interface ITableBookingSlots extends ITableBookingSlotsHandlers {
  _id: string;
  dragFromTableId: string;
  slots: ITableBookingSlot[];
  selectedTime: Date;
  parentShape: FloorplanTableShape;
  draggedBooking: IBooking;
  isTimeNow?: boolean;
  showCustomerNameOnBooking?: boolean;
  showTimeRemainingOnBooking?: boolean;
  draggedBookingSource?: DraggedBookingSourceEnum;
  tableStatus?: TableStatusEnum
  // @todo: move all handlers to slotHandlers: ITableBookingSlotsHandlers;
  handlePointerDownForDrag?: (evt: IPageCoords, booking: IBooking, slotIndex: number, skipRoughPress: boolean) => void;
  handleBookingPress?: (booking: IBooking) => void;
  handleConflictPress?: (bookings: IBooking[]) => void;
  handleEmptySlotPress?: (data: INewSlotPress) => void;
  handleDragOver?: (slotIndex: number, isUpEvent: boolean) => void;
}
export interface ITableBookingSlotsHandlers {
  handleMouseHoverEnter?: (slotIndex: number, centerX: number, topY: number, offsetY: number) => void;
  clearFloatingBookingCard?: () => void;
  handleLongTouch?: (slotIndex: number, centerX: number, topY: number, offsetY: number) => void;
}

export interface ITableBookingSlot {
  startTime: Date;
  endTime: Date;
  bookings: IBooking[];
  isBlockOut: boolean;
  isConflict: boolean;
  isJoined: boolean;
  partiallyAvailableMins?: number;
  tableStatusIcon?: FloorplanTableStatusIcon;
  shouldHandleDragOver?: boolean;
  isEndOfTheDay?: boolean;
}
